import React from "react";
import "./IntroBand.css";
import { Grid, Row, Col } from "react-bootstrap";
import { prefix } from "../../scripts/helpers/constants";

const introBand = props => {
  return (
    <section className={prefix + "-c-intro-band"}>
      <Grid className="intro-sub-band" fluid={true}>
        <Row className="intro-band-body">
          <Col xs={12}>
            <h3>{props.data.title}</h3>
            {/* <p className="p2">{props.data.content}</p> */}

            <p className="p2">
              Our supportive community of educators, parents and students
              develops the academic and moral strengths of every child. Explore
              our schools below, which are beginning <span>on time</span> and
              offering <span>in-person</span> instruction.
            </p>
          </Col>
        </Row>
      </Grid>
    </section>
  );
};

export default introBand;



// WEBPACK FOOTER //
// ./src/components/IntroBand/IntroBand.js